interface IAssociatedLite {
  name?: string;
  value?: unknown;
}

export interface ITaskDeletedHubLogLite {
  id?: string;
  associatedRecords?: IAssociatedLite[];
}

/**
 * Resolves cosmos alert IDs to dismiss from a TaskDeleted hub payload.
 */
export function collectDeletedTaskToastIds(log: ITaskDeletedHubLogLite | null | undefined): string[] {
  const raw = log?.associatedRecords?.find(r => r?.name === 'DeletedAlertIds')?.value;
  if (raw !== undefined && raw !== null && String(raw).trim().length > 0) {
    return String(raw)
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }

  return log?.id ? [String(log.id)] : [];
}

export function readTaskIdFromAssociatedRecords(records?: IAssociatedLite[]): number | undefined {
  const rec = records?.find(r => r?.name === 'TaskId');
  if (rec?.value === undefined || rec?.value === null) {
    return undefined;
  }
  const n = Number(rec.value);
  return Number.isFinite(n) ? n : undefined;
}
